import { TextField } from '@mui/material';
import { GROUP, GuideType, IdPCommonInputFieldName, Method } from 'consts';
import {
	useCurrentGuideIdPID,
	useIdPConfigContext
} from 'contexts/IdPConfigContext';
import {
	useField,
	useSSOConfigMappings
} from 'contexts/SSOConfigFieldsContext';
import React from 'react';

const GroupsAttributeNameField: React.FC = () => {
	// Guide-aware idp/method so the field reads and persists in the XAA/SCIM contexts too.
	// The idp resolver is pure-context; for the method, keep the raw context method for
	// SSO/SCIM but force Method.Xaa in the XAA guide (the raw method is null there, which
	// left the field stuck reading '' and uneditable). Avoid useCurrentGuideMethod here: it
	// pulls a useConfigs subscription into the field, firing async fetches on every render.
	const idpID = useCurrentGuideIdPID();
	const { method: rawMethod, guideType } = useIdPConfigContext();
	const method = guideType === GuideType.XAA ? Method.Xaa : rawMethod;

	const {
		getGroupsAttributeName,
		setGroupsAttributeName,
		isGroupsAttributeRequired
	} = useSSOConfigMappings();

	const { error } = useField(IdPCommonInputFieldName.GroupsAttribute);

	const groupsAttributeNameMapping =
		idpID && method ? getGroupsAttributeName() : null;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = e.target.value;
		setGroupsAttributeName(
			groupsAttributeNameMapping
				? {
						...groupsAttributeNameMapping,
						idpAttr: newValue
					}
				: {
						idpAttr: newValue,
						spAttr: GROUP
					}
		);
	};

	return (
		<TextField
			data-testid="groups-attribute-name-field"
			autoComplete="off"
			size="small"
			value={groupsAttributeNameMapping?.idpAttr ?? ''}
			onChange={handleChange}
			sx={{ flexGrow: 1, flexBasis: 0, maxWidth: 487 }}
			label={intl.tr('ssoConfig.fields.groupsAttributeNameFieldLabel')}
			slotProps={{
				inputLabel: { shrink: true }
			}}
			required={isGroupsAttributeRequired()}
			error={!!error}
			helperText={error?.message}
		/>
	);
};

export default GroupsAttributeNameField;
